import type { FC } from "react";

import { CountryCode } from "@krea/shared/types/common";

import type { IBankIDProps } from "../common-types";
import { FIBankIDFlow } from "../FI/FIBankIDFlow";
import { SEBankIDFlow } from "../SE/SEBankIDFlow";

export const BankIDAuth: FC<IBankIDProps> = ({
  countryCode,
  errorComponent,
  ...restProps
}) => {
  switch (countryCode) {
    case CountryCode.SE:
      return (
        <SEBankIDFlow
          countryCode={countryCode}
          errorComponent={errorComponent}
          {...restProps}
        />
      );
    case CountryCode.FI:
      return (
        <FIBankIDFlow
          countryCode={countryCode}
          errorComponent={errorComponent}
          {...restProps}
        />
      );
    default:
      throw new Error(`Unsupported country code: ${countryCode}`);
  }
};
